"use client";
import { CountryInfo } from "@/store/types/countryTypes";
import { College } from "@/store/types/universityTypes";
import { checkCountry, replacedName } from "@/utils/Constants";
import { capitalFirstLetter } from "@/utils/capitalFirstLetter";
import { getImageBanner } from "@/utils/imageExtractor";
import { lowerCase } from "@/utils/lowercase";
import { useParams, useRouter } from "next/navigation";
import { useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CommonAuth from "../auth/CommonAuth";
import EmailVerification from "../common/EmailVerificationPopup";
import UniversitiesCards from "../common/UniversitiesCards";
import { Close } from "../common/Icons";
import NewUniversitiesCards from "../newSearch/NewUniversitiesCards";
import NewUniversityCard from "../institutions/common/NewUniversityCard";

const TopUniversity = ({
  country,
  universityList,
}: {
  country: CountryInfo;
  universityList: College[];
}) => {
  const router = useRouter();
  const { id } = useParams();
  const [registrationLoginPopup, setRegistrationLoginPopup] =
    useState<boolean>(false);
  const [emailVerificationPopUp, setEmailVerificationPopup] =
    useState<boolean>(false);

  return (
    <div className="mt-12 bg-white sm:rounded-3xl">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-3 text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-[28px] 3xl:text-[32px] font-semibold mb-1 xl:leading-9 px-6 sm:px-3 pt-5">
          Top Universities to Study in the{" "}
          {lowerCase(country?.countryName) === checkCountry
            ? replacedName
            : capitalFirstLetter(country?.countryName)}
        </h2>

        <span
          className="underline font-semibold ff_poppins cursor-pointer hidden sm:block"
          onClick={() => router.push(`/all-universities/${id}`)}
        >
          View All Universities
        </span>
      </div>

      <div className="sm:py-5 relative px-3">
        <Swiper
          navigation={true}
          modules={[Navigation]}
          slidesPerView={1}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            1500: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
          }}
        >
          {universityList &&
            universityList?.length > 0 &&
            universityList.map((inst, idx) => {
              const formattedName = inst?.college_name?.replace(/\s+/g, "_");
              const propData = {
                id: idx,
                image: getImageBanner(
                  formattedName,
                  inst?.address_info?.country,
                ),
                title: inst?.college_name || "",
                popularity: inst?.popularity || "Popular",
                founded: inst?.founded_year || "",
                qsRanking:
                  inst?.rank_details?.["QS Ranking"] === undefined
                    ? ""
                    : inst?.rank_details["QS Ranking"],
                usRanking:
                  inst?.rank_details?.["US News & World Ranking"] === undefined
                    ? ""
                    : inst?.rank_details["US News & World Ranking"],
                timeRanking:
                  inst?.rank_details?.["Times Higher Education Ranking"] ===
                    undefined
                    ? ""
                    : inst?.rank_details["Times Higher Education Ranking"],
                typeInstitute: inst?.category || "",
                category: inst?.category || "",
                applicationFees: inst?.application_fees,
                currency: inst?.currency || "",
                // fees:
                //   inst?.application_fees != null
                //     ? `${inst?.currency} ${inst?.application_fees}`
                //     : "",
                averageTutionFees: inst.avg_annual_tuition_fee,
                hasScholarship: inst.has_scholarship,

                offerTat: inst.offer_tat || "",
                state: inst?.address_info?.state || "",
                country: inst?.address_info?.country || "",
                courseCount: inst.course_count,
                specialisationCategory: inst.specialisation_category || [],
                collegeId: inst.college_id || "",
                collegeSlug: inst.college_slug,
                intakeStatus: (inst as any)?.intakeStatus || (inst as any)?.intake_status || "",
              };
              return (
                <SwiperSlide key={idx}>
                  <div className="rounded-xl py-5 px-2">
                    {/* <NewUniversitiesCards
                      setRegistrationLoginPopup={setRegistrationLoginPopup}
                      registrationLoginPopup={registrationLoginPopup}
                      setEmailVerificationPopup={setEmailVerificationPopup}
                      emailVerificationPopUp={emailVerificationPopUp}
                      items={propData}
                      detailsButtonText={"View Details"}
                      compare={false}
                      fromSearch={true}
                      showLimitedFields={false}
                    /> */}

                    <NewUniversityCard
                      setRegistrationLoginPopup={setRegistrationLoginPopup}
                      registrationLoginPopup={registrationLoginPopup}
                      setEmailVerificationPopup={setEmailVerificationPopup}
                      emailVerificationPopUp={emailVerificationPopUp}
                      items={propData}
                      detailsButtonText={"View Details"}
                      compare={false}
                      fromSearch={true}
                      showLimitedFields={false}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
        {/* <RegistrationLoginPopup
          setRegistrationLoginPopup={setRegistrationLoginPopup}
          setEmailVerificationPopup={setEmailVerificationPopup}
        /> */}
        {registrationLoginPopup && (
          <div className="fixed inset-0 bg-black/70 z-100">
            <div className="bg-white w-full max-w-[360px] max-h-[100vh] min-w-full px-5 sm:px-7 md:px-8 lg:px-10 3xl:px-14 rounded-xl fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-60 overflow-y-auto custom-scrollbar pb-5 sm:pb-7 md:pb-8 lg:pb-10 3xl:pb-14 pt-3 sm:pt-5 lg:pt-7 3xl:pt-7">
              <span
                onClick={() => setRegistrationLoginPopup(false)}
                className="size-4 md:size-5 xl:size-6 absolute top-4 md:top-5 right-4 md:right-5 xl:top-7 xl:right-7 cursor-pointer"
              >
                <Close />
              </span>
              <CommonAuth setShow={setRegistrationLoginPopup} />
            </div>
          </div>
        )}
        {emailVerificationPopUp && (
          <div
            className="fixed inset-0 bg-black/70 z-100 overflow-hidden flex items-center justify-center"
            onClick={() => setEmailVerificationPopup(false)} // close when clicking backdrop
          >
            <EmailVerification
              setEmailVerificationPopup={setEmailVerificationPopup}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TopUniversity;
